export default __webpack_public_path__ + "static/media/img1.a7551ad3.png";